import React, { useState, useEffect } from 'react';
import { X, Megaphone, AlertCircle, CheckCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';

const AnnouncementBanner = ({ supabase }) => {
    const [announcements, setAnnouncements] = useState([]);
    const [dismissedIds, setDismissedIds] = useState([]);

    useEffect(() => {
        fetchAnnouncements();

        // Load dismissed announcements from localStorage
        const dismissed = JSON.parse(localStorage.getItem('dismissedAnnouncements') || '[]');
        setDismissedIds(dismissed);
    }, []);

    const fetchAnnouncements = async () => {
        try {
            const response = await fetch(`${supabase.supabaseUrl}/functions/v1/announcements`, {
                headers: {
                    'Authorization': `Bearer ${supabase.supabaseKey}`
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch announcements');
            }

            const { announcements: data } = await response.json();
            setAnnouncements(data || []);
        } catch (error) {
            console.error('Error fetching announcements:', error);
            // Fail silently - announcements are not critical
        }
    };

    const handleDismiss = (id) => {
        const newDismissed = [...dismissedIds, id];
        setDismissedIds(newDismissed);
        localStorage.setItem('dismissedAnnouncements', JSON.stringify(newDismissed));
    };

    const visibleAnnouncements = announcements.filter(a => !dismissedIds.includes(a.id));

    if (visibleAnnouncements.length === 0) return null;

    const getIcon = (type) => {
        switch (type) {
            case 'warning':
                return <AlertCircle className="h-4 w-4" />;
            case 'success':
                return <CheckCircle className="h-4 w-4" />;
            default:
                return <Megaphone className="h-4 w-4" />;
        }
    };

    const getVariant = (type) => {
        return type === 'warning' ? 'destructive' : 'default';
    };

    return (
        <div className="space-y-2 mb-4">
            {visibleAnnouncements.map((announcement) => (
                <Alert key={announcement.id} variant={getVariant(announcement.type)} className="relative">
                    <div className="flex items-start gap-3">
                        {getIcon(announcement.type)}
                        <div className="flex-1">
                            <AlertTitle>{announcement.title}</AlertTitle>
                            <AlertDescription className="mt-1">
                                {announcement.message}
                            </AlertDescription>
                        </div>
                        <button
                            onClick={() => handleDismiss(announcement.id)}
                            className="text-muted-foreground hover:text-foreground transition-colors"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    </div>
                </Alert>
            ))}
        </div>
    );
};

export default AnnouncementBanner;
